const pluralize = (count, noun) => {
  return `${count} ${noun}${count === 1 ? '' : 's'}`;
};

export const timeElapsed = (lastSavedAt) => {
  const msPerMinute = 1000 * 60;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msElapsed = Date.now() - lastSavedAt;

  if (msElapsed < msPerMinute) {
    return 'seconds';
  } else if (msElapsed < msPerHour) {
    return pluralize(Math.round(msElapsed / msPerMinute), 'minute');
  } else if (msElapsed < msPerDay) {
    return pluralize(Math.round(msElapsed / msPerHour), 'hour');
  } else if (msElapsed < msPerDay * 31) {
    return pluralize(Math.round(msElapsed / msPerDay), 'day');
  } else {
    return 'more than a month';
  }
};
